import { render, staticRenderFns } from "./DetailOrderWompi.vue?vue&type=template&id=2c557878&scoped=true&"
import script from "./DetailOrderWompi.vue?vue&type=script&lang=js&"
export * from "./DetailOrderWompi.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrderWompi.vue?vue&type=style&index=0&id=2c557878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c557878",
  null
  
)

export default component.exports